/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { getLocationDetails } from '../../../redux/slices/location/locationDetails';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import IsLoadingIndicator from '../../../components/isLoadingIndicator';
import { newConfigsMap } from './config';
import { DEFAULT_RANGE } from '../../../components/datePicker/utils';
import {
  ANALYTICS_NAVBAR_ACTIONS,
  BEST_TIME_TO_POST_LABEL,
  CAMPAIGN_ANALYTICS_LABEL,
  DEMOGRAPHICS_LABEL,
  GROWTH_LABEL,
  OVERVIEW_LABEL,
  POST_PERFORMANCE_LABEL
} from '../../dashboard/config';
import AnalyticsPagesLayout from '../../../components/analyticsPagesLayout';
import {
  getAnalyticsForLocation,
  transferData
} from '../../../redux/slices/analytics/plotsData';
import { LINKEDIN_PERSONAL_ACCOUNT } from '../../../config/constants';
import { data } from './demoDataDocument';
import { getUserDetails } from '../../../redux/slices/user/userDetails';
import { ANALYICS_FOR_SOCIAL_MEDIA } from '../../../config/firebase/collections';
import PostPerformance from '@/pages/allAnalytics/sections/postPerformance';
import CampaignAnalysis from '@/pages/allAnalytics/sections/campaignAnalytics';
import { fetchDemographics } from '../../../redux/slices/analytics/demographics';
import LinkedinPersonalAccountOverviewTab from './LinkedinPersonalAccountOverviewTab';
import LinkedinPersonalAccountBestTimeToPostTab from './LinkedinPersonalAccountBestTimeToPostTab';
import LinkedinPersonalAccountDemographicsTab from './LinkedinPersonalAccountDemographicsTab';
import GrowthTab from '../shared/GrowthTab';

const LinkedinPersonalAccountAnalytics: React.FC = () => {
  const { isLoading, uuid, demo, platforms_information: platformsInformation } = useSelector(
    (state: any) => state.locationDetails
  );
  const dispatch = useDispatch();
  const { locationslug } = useParams();
  const [error, setError] = useState(false);

  useEffect(() => {
    dispatch(getUserDetails() as unknown as AnyAction);
  }, [dispatch]);

  useEffect(() => {
    if (locationslug ?? '') {
      dispatch(getLocationDetails(locationslug) as unknown as AnyAction);
    }
  }, [dispatch, locationslug]);

  // Fetch demographics data when uuid is available
  useEffect(() => {
    if (uuid && !demo) {
      dispatch(fetchDemographics(uuid) as any);
    }
  }, [dispatch, uuid, demo]);

  const [dates, setDates] = useState({
    ...DEFAULT_RANGE
  });
  const type = 'social_media_profile';
  const [plotsData, setPlotsData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (demo) {
      setPlotsData(data);
      setLoading(false);
      return;
    }
    if (!dates) return;
    if (
      !isLoading &&
      uuid &&
      Object.keys(platformsInformation).includes(LINKEDIN_PERSONAL_ACCOUNT)
    ) {
      setLoading(true);
      setError(false);
      getAnalyticsForLocation(
        ANALYICS_FOR_SOCIAL_MEDIA,
        type,
        platformsInformation[LINKEDIN_PERSONAL_ACCOUNT]?.[0]?.uuid,
        dates,
        LINKEDIN_PERSONAL_ACCOUNT
      )
        .then((res) => {
          console.log('✅ [LinkedIn Personal] Raw API response:', res);
          const transformedData = transferData(res, newConfigsMap);
          console.log('✅ [LinkedIn Personal] Final processed data:', transformedData);
          setPlotsData(transformedData);
          setLoading(false);
        })
        .catch((err) => {
          setError(true);
          setLoading(false);
        });
    }
  }, [uuid, isLoading, dates, platformsInformation]);
  
  if (isLoading) return <IsLoadingIndicator />;
  
  return (
    <Container>
      <AnalyticsPagesLayout
        actions={ANALYTICS_NAVBAR_ACTIONS}
        tabs={{
          [OVERVIEW_LABEL]: (
            <LinkedinPersonalAccountOverviewTab
              dates={dates}
              setDates={setDates}
              plotsData={plotsData}
              loading={loading}
              error={error}
              newConfigsMap={newConfigsMap}
            />
          ),
          [BEST_TIME_TO_POST_LABEL]: <LinkedinPersonalAccountBestTimeToPostTab />,
          [DEMOGRAPHICS_LABEL]: <LinkedinPersonalAccountDemographicsTab />,
          [POST_PERFORMANCE_LABEL]: (
            <PostPerformance platform={LINKEDIN_PERSONAL_ACCOUNT} />
          ),
          [GROWTH_LABEL]: (
            <GrowthTab
              dates={dates}
              setDates={setDates}
              plotsData={plotsData}
              newConfigsMap={newConfigsMap}
              error={error}
              loading={loading}
              show_data_import_info={false}
              locationslug={locationslug}
            />
          ),
          [CAMPAIGN_ANALYTICS_LABEL]: (
            <CampaignAnalysis platform={LINKEDIN_PERSONAL_ACCOUNT} />
          )
        }}
      />
    </Container>
  );
};
export default LinkedinPersonalAccountAnalytics;
